module.exports = __webpack_public_path__ + "static/img/ciudadania_digital.986f361.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ciudadania_digital.jpg
// module id = /SEr
// module chunks = 9